import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  background-color: #1D2C3B;
`;

export const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  padding: 1.5rem 2rem;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const TabsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--white);
  padding: 0.75rem 2rem;
  margin: 1rem;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 0.75rem 1rem;
    gap: 0.75rem;
  }
`;

export const TabsWrapper = styled.div`
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: space-between;
    gap: 0.5rem;
  }
`;

interface TabProps {
  isActive: boolean;
}

export const Tab = styled.button<TabProps>`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.625rem 1.25rem;
  background-color: ${(props) => (props.isActive ? "#00467E" : "white")};
  color: ${(props) => (props.isActive ? "white" : "#1D2C3B")};
  border: 1px solid var(--clear-gray);
  border-radius: 2px;
  font-size: 0.9375rem;
  font-weight: 400;
  transition: all 0.2s ease;
  white-space: nowrap;
  cursor: pointer;

  &:active {
    transform: scale(0.98);
  }

  @media (max-width: 768px) {
    flex: 1;
    justify-content: center;
    font-size: 0.875rem;
    padding: 0.5rem 0.75rem;
  }
`;

interface BadgeProps {
  isActive: boolean;
}

export const Badge = styled.span<BadgeProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.375rem;
  background-color: ${(props) => (props.isActive ? "#839DB4" : "transparent")};
  color: ${(props) => (props.isActive ? "white" : "#000")};
  border-radius: 2px;
  font-size: 0.75rem;
  font-weight: 500;
  transition: background-color 0.2s ease;

  @media (max-width: 768px) {
    min-width: 1.25rem;
    height: 1.25rem;
    font-size: 0.6875rem;
  }
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 300px;
  border: 1px solid var(--clear-gray);
  border-radius: 2px;

  @media (max-width: 768px) {
    width: 100%;
    min-width: unset;
  }
`;

export const SearchIcon = styled.div`
  position: absolute;
  left: 0.875rem;
  display: flex;
  align-items: center;
  color: var(--blue);
  font-size: 1.125rem;
  pointer-events: none;
`;

export const SearchInput = styled.input`
  width: 100%;
  padding: 0.625rem 0.875rem 0.625rem 2.75rem;
  background-color: var(--white);
  border: none;
  border-radius: 2px;
  font-size: 0.9375rem;
  color: var(--text-gray);
  outline: none;
  transition: box-shadow 0.2s ease;

  &::placeholder {
    color: var(--clear-gray);
  }

  @media (max-width: 768px) {
    font-size: 0.875rem;
    padding: 0.5625rem 0.75rem 0.5625rem 2.5rem;
  }
`;

export const RequestsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const RequestCard = styled.div`
  background-color: #00468B;
  border-radius: 2px;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 0.75rem;
  }
`;

export const VideoIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
`;

export const UserName = styled.span`
  color: white;
  font-size: 1rem;
  font-weight: 500;
`;

export const RequestDate = styled.span`
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.875rem;
`;

export const CategoryTag = styled.span`
  padding: 0.375rem 0.75rem;
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  border-radius: 2px;
  font-size: 0.875rem;
`;

export const CardActions = styled.div`
  display: flex;
  gap: 0.75rem;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Dropdown = styled.div`
  position: relative;
`;

interface DropdownButtonProps {
  status?: "pendente" | "respondida";
}

export const DropdownButton = styled.button<DropdownButtonProps>`
  padding: 0.5rem 1rem;
  background-color: ${props => props.status === "respondida" ? "#28a745" : "white"};
  color: ${props => props.status === "respondida" ? "white" : "#1D2C3B"};
  border: none;
  border-radius: 2px;
  font-size: 0.875rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;

  &:hover {
    filter: brightness(0.95);
  }
`;

export const DropdownMenu = styled.div`
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  min-width: 180px;
  z-index: 1000;
  overflow: hidden;
`;

export const DropdownItem = styled.button`
  width: 100%;
  padding: 0.75rem 1rem;
  background: white;
  border: none;
  text-align: left;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #f5f5f5;
  }

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.25rem;

  &:hover {
    opacity: 0.8;
  }
`;

export const VideoContainer = styled.div`
  padding: 1.5rem;
  background-color: #00467E;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const VideoDescription = styled.p`
  color: white;
  font-size: 0.9375rem;
  line-height: 1.6;
  margin-bottom: 1rem;
`;

export const VideoPlayerWrapper = styled.div`
  background-color: #000;
  border-radius: 2px;
  overflow: hidden;
`;

export const Video = styled.video`
  width: 100%;
  height: auto;
  max-height: 400px;
  display: block;
  background-color: #666;
`;

export const VideoControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background-color: rgba(0, 0, 0, 0.8);
`;

export const ControlButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-radius: 50%;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const TimeInfo = styled.span`
  color: white;
  font-size: 0.875rem;
  font-family: monospace;
  min-width: 45px;
`;

export const ProgressBarContainer = styled.div`
  flex: 1;
`;

export const ProgressBar = styled.input`
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    background: white;
    border-radius: 50%;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    background: white;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

export const ModalContent = styled.div`
  background-color: white;
  border-radius: 2px;
  width: 90%;
  max-width: 450px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
`;

export const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);

  button {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: #666;
  }
`;

export const ModalTitle = styled.h2`
  font-size: 1.25rem;
  font-weight: 500;
  color: var(--text-gray);
  margin: 0;
`;

export const ModalBody = styled.div`
  padding: 1.5rem;
  font-size: 1rem;
  line-height: 1.6;
  color: var(--text-gray);
`;

export const ModalFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
`;

interface ModalButtonProps {
  primary?: boolean;
}

export const ModalButton = styled.button<ModalButtonProps>`
  padding: 0.625rem 1.5rem;
  background-color: ${props => props.primary ? "var(--blue)" : "transparent"};
  border: ${props => props.primary ? "none" : "1px solid rgba(0, 0, 0, 0.2)"};
  border-radius: 2px;
  font-size: 0.9375rem;
  color: ${props => props.primary ? "white" : "var(--text-gray)"};
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    ${props => props.primary ? "background-color: var(--dark-blue);" : "background-color: rgba(0, 0, 0, 0.05);"}
  }
`;

export const HeaderContainer = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem;
  background-color: #00468B;
  min-height: 60px;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    width: 40px;
    height: 40px;
  }

  @media (max-width: 768px) {
    img {
      width: 32px;
      height: 32px;
    }
  }
`;

export const Title = styled.h1`
  color: var(--white);
  font-size: 1.25rem;
  font-family: 'Roboto',sans-serif;
  font-weight: 100;

  @media (max-width: 768px) {
    font-size: 1.10rem;
  }
`;

export const SettingsButton = styled.button`
  background: none;
  border: none;
  color: var(--white);
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  border-radius: 2px;
  cursor: pointer;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &:active {
    transform: scale(0.95);
  }

  @media (max-width: 768px) {
    font-size: 1.25rem;
  }
`;
